/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { showToast } from '../../showTost';
import Payment from '../../PaymentGateway/Payment';
import { uid } from 'uid';
import Chat from './Chat';
const OrderDetails = () => {

    const PaymentList = [
        { id: "1", title: "Razorpay" },
        { id: '3', title: 'Paypal' },
        { id: '4', title: 'Stripe' },
        { id: '5', title: 'Wallet' },
        { id: '6', title: 'PayStack' },
        { id: '7', title: 'FlutterWave' },
        { id: '8', title: 'Paytm' },
        { id: '10', title: 'SenangPay' },
        { id: '11', title: 'MercadoPago' },
        { id: '12', title: 'Payfast' },
        { id: '13', title: 'Midtrans' },
        { id: '15', title: 'Khalti Payment' },
        { id: '14', title: '2checkout' },
        { id: '16', title: 'Cash On Delivery' }
    ]

    const { t } = useTranslation();
    const { ApiBasUrl, ImgBasUrl, paymentRes, setPaymentRes } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [detailsdata, setDetailsData] = useState("");
    const [serviceslist, setServicesList] = useState([]);
    const [showpaymentlist, setShowPaymentList] = useState(false);
    const [showreviewbox, setShowReviewBox] = useState(false);
    const [rating, setRating] = useState(1);
    const [comment, setComment] = useState("");
    const [selectratitem, setSelectRatItem] = useState("");
    const [ratinglod, setRatingLod] = useState(false);
    const [bookinglod, setBookingLod] = useState(false);
    const [mywallet, setMyWallet] = useState(0);
    const [myusedwallet, setMyUsedWallet] = useState(0);
    const [isDriverSelected, setIsDriverSelected] = useState(false);
    const [showchatlist, setShowChatList] = useState(false);

    const Currency = secureLocalStorage.getItem("currency");
    const Paymentamt = isDriverSelected ? detailsdata?.total_extra_charge - myusedwallet : detailsdata?.total_extra_charge;

    const PaymentMethodGet = PaymentList.map(item => {
        if (item.id == detailsdata?.payment_id) {
            if (detailsdata?.payment_id !== "16" && detailsdata?.wall_amt === "0") {
                return item.title;
            } else if (detailsdata?.payment_id === "5" && detailsdata?.wall_amt !== "0") {
                return item.title;
            } else if (detailsdata?.payment_id !== "5" && detailsdata?.wall_amt !== "0") {
                return `${item.title} & Wallet`;
            } else if (detailsdata?.payment_id === "16" && detailsdata?.wall_amt === "0") {
                return item.title;
            } else if (detailsdata?.payment_id === "16" && detailsdata?.wall_amt !== "0") {
                return `${item.title} & Wallet`;
            }
        }
    });

    const ChargePaymentMethodGet = PaymentList.map(item => {
        if (item.id == detailsdata?.charge_payment_id) {
            if (detailsdata?.charge_payment_id !== "16" && detailsdata?.charge_wall_amt === "0") {
                return item.title;
            } else if (detailsdata?.charge_payment_id === "5" && detailsdata?.charge_wall_amt !== "0") {
                return item.title;
            } else if (detailsdata?.charge_payment_id !== "5" && detailsdata?.charge_wall_amt !== "0") {
                return `${item.title} & Wallet`;
            } else if (detailsdata?.charge_payment_id === "16" && detailsdata?.charge_wall_amt === "0") {
                return item.title;
            } else if (detailsdata?.charge_payment_id === "16" && detailsdata?.charge_wall_amt !== "0") {
                return `${item.title} & Wallet`;
            }
        }
    });



    const toggleDriverSelection = () => setIsDriverSelected(prev => !prev);

    useEffect(() => {
        setMyWallet(secureLocalStorage.getItem("mywallet"));
        handlefetchdata();
        const PaymentResponse = sessionStorage.getItem("Paymentstatus");
        if (!PaymentResponse) return;
        if (PaymentResponse === "PaymentDone") {
            setPaymentRes("PaymentDone");
        } else {
            setPaymentRes("PaymentFaild");
        }
    }, []);

    const handlefetchdata = () => {
        const service_id = sessionStorage.getItem("bookid");

        axios.post(`${ApiBasUrl}/service_details.php`, { service_id })
            .then((res) => {
                setDetailsData(res.data.OrderInfo);
                setServicesList(res.data.Services);
                setLoading(false);
            })
            .catch((error) => {
                console.error("service_details.php", error);
            });
    };

    const formatCustomDate = (dateStr) => {

        const date = new Date(dateStr);

        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        const dayName = days[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        return `${dayName}, ${day} ${month}, ${year}`;
    };

    const handleContinue = () => {
        if (myusedwallet == detailsdata?.total_extra_charge) {
            handleExtraCharge();
            return;
        }
        setShowPaymentList(true);
    };

    const HandleSubmit = () => {

        if (!comment) {
            showToast({ title: "Please enter comment !!", id: "error" });
            return;
        }

        const Userid = secureLocalStorage.getItem("Userid");
        setRatingLod(true);

        const Data = {
            uid: Userid,
            service_id: selectratitem?.service_id,
            order_id: selectratitem?.order_id,
            total_rate: String(rating),
            rate_text: comment,
            service_product_id: selectratitem?.service_product_id,
            item_type: selectratitem?.item_type
        };

        axios.post(`${ApiBasUrl}/u_rate_update.php`, Data)
            .then((res) => {
                const toastId = res.data.ResponseCode === "200" ? "success" : "error";
                showToast({ title: res.data.ResponseMsg, id: toastId });
                setRatingLod(false);
                setShowReviewBox(false);
                handlefetchdata();
            })
            .catch((error) => {
                console.error("u_rate_update.php", error);
            });
    };

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            setBookingLod(true);
            handleExtraCharge();
            setPaymentRes("");

        } else {
            showToast({ title: t("Payment Faild !!"), id: "error" });
            setPaymentRes("");
        }
    }, [paymentRes]);

    useEffect(() => {
        const isWalletSufficient = mywallet > detailsdata?.total_extra_charge;

        if (isWalletSufficient) {
            if (isDriverSelected) {
                const Total = mywallet - detailsdata?.total_extra_charge;
                setMyWallet(Total);
                setMyUsedWallet(mywallet - Total);
            } else {
                setMyWallet(secureLocalStorage.getItem("mywallet"));
                setMyUsedWallet(0);
            }
        } else {
            if (isDriverSelected) {
                setMyWallet(0);
                setMyUsedWallet(mywallet);
            } else {
                setMyWallet(secureLocalStorage.getItem("mywallet"));
                setMyUsedWallet(0);
            }
        }

    }, [isDriverSelected]);

    const handleExtraCharge = () => {

        const Userid = secureLocalStorage.getItem("Userid");
        const Paymentid = secureLocalStorage.getItem("Paymentid");
        const transactionId = sessionStorage.getItem("transactionid");
        const Bookingid = sessionStorage.getItem("bookid");
        const total = myusedwallet === Number(detailsdata?.total_extra_charge);

        const ApiData = {
            uid: Userid,
            book_id: detailsdata?.main_service_id || Bookingid,
            charge_payment_id: total ? "5" : Paymentid,
            charge_transaction_id: total ? "0" : transactionId || uid(15),
            charge_wall_amt: myusedwallet
        };

        axios.post(`${ApiBasUrl}/paid_extra_charge.php`, ApiData)
            .then((res) => {
                handlefetchdata();
                showToast({ title: res.data.message, id: "success" });
                setShowPaymentList(false);
                setBookingLod(false);
                sessionStorage.removeItem("transactionid");
                sessionStorage.removeItem("Paymentstatus");
            })
            .catch((error) => {
                console.error("paid_extra_charge.php", error);
            });
    };

    return (
        <div className='order_details_page'>

            {loading
                ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                    <div className="loader2"></div>
                </div>
                : <div className="width_container">

                    <div className="flex items-center justify-between max-_430_:hidden">
                        <div className="border-[2px] rounded-[50px] px-[15px] py-[3px] cursor-pointer hover:bg-gray-800 group">
                            <Link to="/" className="flex items-center gap-[8px] group-hover:text-white">
                                <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.35401 8.64601C5.54901 8.84101 5.54901 9.15804 5.35401 9.35304C5.25601 9.45104 5.12801 9.49903 5.00001 9.49903C4.87201 9.49903 4.74401 9.45004 4.64601 9.35304L0.646006 5.35304C0.451006 5.15804 0.451006 4.84101 0.646006 4.64601L4.64601 0.646006C4.84101 0.451006 5.15804 0.451006 5.35304 0.646006C5.54804 0.841006 5.54804 1.15804 5.35304 1.35304L1.70704 4.99903L5.35401 8.64601Z" fill="currentColor" />
                                </svg>
                                <h1 className='font-bold'>{t("Home")}</h1>
                            </Link>
                        </div>
                        <div className="flex items-center gap-[10px] font-[500]">
                            <Link to="/order-history" className='text-gray-600'>{t("Order History")}</Link>
                            <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.35401 5.35401L1.35401 9.35401C1.25601 9.45201 1.12801 9.50001 1.00001 9.50001C0.87201 9.50001 0.744006 9.45101 0.646006 9.35401C0.451006 9.15901 0.451006 8.84198 0.646006 8.64698L4.292 5.00099L0.646006 1.35499C0.451006 1.15999 0.451006 0.842959 0.646006 0.647959C0.841006 0.452959 1.15804 0.452959 1.35304 0.647959L5.35304 4.64796C5.54904 4.84196 5.54901 5.15801 5.35401 5.35401Z" fill="#25314C" />
                            </svg>
                            <h1 className='text-gray-400'>{t("Order Details")}</h1>
                        </div>
                    </div>

                    <div className="flex flex-wrap items-start justify-center gap-[20px] my-[20px]">

                        <div className="order_box">
                            <div className="">
                                {serviceslist.map((item, index) => {
                                    return <div key={index} className={`${index >= 1 && "mt-[10px]"} border-[1px] p-[10px] rounded-[10px] border-gray-300 flex items-center justify-between`}>
                                        <div className="flex items-center gap-[10px] overflow-hidden">
                                            <img src={ImgBasUrl + item.img} className='w-[80px] h-[80px] border-gray-300 object-cover rounded-[10px] border-[1px]' alt="img" />
                                            <div className="overflow-hidden leading-5">
                                                <h1 className='font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.title}</h1>
                                                <div className="flex items-center gap-[10px]">
                                                    <span className={`font-[500] ${item.discount_price !== "0" && "text-gray-500 line-through"}`}>{Currency + item.price}</span>
                                                    {item.discount_price !== "0" && <span className='font-[500]'>{Currency}{item.discount_price}</span>}
                                                </div>
                                                {item.item_type === "accessory" && <span className='whitespace-nowrap text-[14px] text-[#682afb]'>{t("Quantity")} : {item.quantity}</span>}
                                                <div className="flex items-center justify-start">
                                                    {["1", "2", "3", "4", "5"].map((num, index) => {
                                                        return <div key={index} className={`${item.rate_number >= num ? "text-orange-400" : "text-gray-300"}`}>
                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                                            </svg>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        {detailsdata?.service_status === "Delivered" && <div onClick={() => { item.is_review === "0" && setSelectRatItem(item); item.is_review === "0" && setShowReviewBox(true); }} className={`${item.is_review === "1" ? "text-gray-400 border-gray-400 cursor-auto" : "text-[#682afb] border-[#682afb]"} cursor-pointer font-[500] border-[1px] px-[10px] py-[2px] rounded-[10px]`}>{t("Review")}</div>}
                                    </div>
                                })}
                            </div>

                            <div className="max-_995_:hidden">

                                {detailsdata?.total_extra_charge && <div className="border-[1px] py-[5px] p-[15px] rounded-[10px] mt-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Extra Charge")}</h1>

                                    <div className="flex items-center justify-between py-[3px]">
                                        <h1>{t("Total Extra Charge")}</h1>
                                        <span className='font-[500]'>{Currency}{detailsdata?.total_extra_charge}</span>
                                    </div>

                                    {(detailsdata?.is_paid === "1" && detailsdata?.charge_transaction_id !== "0") && <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                        <h1>{t("Charge Transaction Id")}</h1>
                                        <span className='font-[500]'>{detailsdata?.charge_transaction_id}</span>
                                    </div>}

                                    {detailsdata?.is_paid === "1" && <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                        <h1>{t("Payment Method")}</h1>
                                        <span className='font-[500]'>{ChargePaymentMethodGet}</span>
                                    </div>}

                                    <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                        <h1>{t("Charge Status")}</h1>
                                        <span className='font-[500]'>{detailsdata?.is_paid === "0" ? t("Unpaid") : t("Paid")}</span>
                                    </div>

                                    {(detailsdata?.is_paid === "0" && secureLocalStorage.getItem("mywallet") !== 0) && <div className="border-[1px] border-gray-300 rounded-[10px] py-[10px] px-[20px] mt-[20px]">
                                        <div className="flex items-center justify-between mb-[10px]">
                                            <h1 className='font-[500] text-[17px]'>{t("Pay from Wallet")}</h1>
                                            <label className="switch">
                                                <input type="checkbox" checked={isDriverSelected} onChange={toggleDriverSelection} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                        <div className="border-[1px] border-[#8080803b] p-[10px] rounded-[10px] flex items-center justify-between">
                                            <div className="flex items-center gap-[5px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                                                </svg>
                                                <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                                            </div>
                                            <h1 className='font-[500] text-[17px] text-[#682afb]'>{Currency}{mywallet}</h1>
                                        </div>
                                    </div>}

                                </div>}


                                {(detailsdata?.is_paid === "0" && detailsdata?.total_extra_charge) && <button onClick={handleContinue} className='button rounded-[10px] mt-[10px]'>{t("Pay Extra Charge")} {myusedwallet - Number(detailsdata?.total_extra_charge) === 0 ? "" : Currency + Paymentamt}</button>}
                            </div>

                        </div>

                        <div className="order_box">

                            <div className="border-[1px] py-[5px] p-[15px] rounded-[10px]">
                                <div className="flex items-center justify-between py-[5px]">
                                    <h1>{t("Order Status")}</h1>
                                    <span className='font-[500]'>{detailsdata?.service_status}</span>
                                </div>
                                <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                    <h1>{t("Order id")}</h1>
                                    <span className='font-[500]'>{detailsdata?.main_service_id}</span>
                                </div>
                                <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                    <h1>{t("Order Date")}</h1>
                                    <span className='font-[500]'>{formatCustomDate(detailsdata?.order_date)}</span>
                                </div>
                                <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                    <h1>{t("Book Date")}</h1>
                                    <span className='font-[500]'>{formatCustomDate(detailsdata?.book_date)}</span>
                                </div>
                                <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                    <h1>{t("Order Time")}</h1>
                                    <span className='font-[500]'>{detailsdata?.timeslot}</span>
                                </div>
                                <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                    <h1>{t("Payment Method")}</h1>
                                    <span className='font-[500]'>{PaymentMethodGet}</span>
                                </div>
                                <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                    <h1>{t("Mode")}</h1>
                                    <span className='font-[500]'>{detailsdata?.mode_service}</span>
                                </div>
                                {detailsdata?.transaction_id !== "0" && <div className="flex items-center justify-between border-t-[2px] border-dashed py-[5px]">
                                    <h1>{t("Transaction id")}</h1>
                                    <span className='font-[500]'>{detailsdata?.transaction_id}</span>
                                </div>}
                            </div>

                            <div className="border-[1px] py-[5px] p-[15px] rounded-[10px] mt-[10px]">
                                <h1 className='font-[500] text-[17px]'>{t("Address")}</h1>
                                <p>{detailsdata?.address?.houseno} ,{detailsdata?.address?.address}</p>
                            </div>

                            <div className="border-[1px] py-[5px] p-[15px] rounded-[10px] mt-[10px]">
                                <div className="flex items-center justify-between">
                                    <h1 className='font-[500] text-[17px]'>{t("Store Address")}</h1>
                                    {detailsdata?.service_status !== "Pending" && <button onClick={() => setShowChatList(true)} className='bg-[#682afb] py-[5px] px-[10px] rounded-[10px]'>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.85693 21.75C3.71193 21.75 3.57111 21.748 3.43311 21.743C2.93311 21.731 2.49497 21.411 2.32397 20.928C2.15197 20.442 2.29408 19.9131 2.68408 19.5811C3.61608 18.8291 3.98892 17.997 4.13892 17.426C2.90192 15.947 2.24902 14.08 2.24902 12.001C2.24902 6.84798 6.25902 3.25 11.999 3.25C17.739 3.25 21.749 6.84898 21.749 12.001C21.749 17.153 17.739 20.752 11.999 20.752C10.812 20.752 9.67398 20.591 8.60498 20.2729C7.24198 21.4599 5.36393 21.75 3.85693 21.75ZM3.47803 20.243C3.48003 20.243 3.48189 20.243 3.48389 20.243C3.48089 20.244 3.47903 20.244 3.47803 20.243ZM12 4.75C7.143 4.75 3.75 7.73198 3.75 12.001C3.75 13.837 4.35498 15.463 5.50098 16.703C5.65598 16.871 5.72692 17.101 5.69092 17.328C5.52292 18.399 4.99511 19.412 4.18311 20.243C5.34311 20.201 6.90304 19.934 7.86304 18.91C8.06404 18.694 8.37603 18.617 8.65503 18.714C9.69003 19.072 10.815 19.2531 12 19.2531C16.857 19.2531 20.25 16.271 20.25 12.002C20.25 7.73295 16.857 4.75 12 4.75ZM13.02 12C13.02 11.448 12.573 11 12.02 11H12.01C11.458 11 11.0149 11.448 11.0149 12C11.0149 12.552 11.468 13 12.02 13C12.572 13 13.02 12.552 13.02 12ZM17.02 12C17.02 11.448 16.573 11 16.02 11H16.01C15.458 11 15.0149 11.448 15.0149 12C15.0149 12.552 15.468 13 16.02 13C16.572 13 17.02 12.552 17.02 12ZM9.02002 12C9.02002 11.448 8.57302 11 8.02002 11H8.01001C7.45801 11 7.01489 11.448 7.01489 12C7.01489 12.552 7.46802 13 8.02002 13C8.57202 13 9.02002 12.552 9.02002 12Z" fill="white" />
                                        </svg>
                                    </button>}
                                </div>
                                <p>{detailsdata?.store_address}</p>
                            </div>

                            <div className="border-[1px] py-[5px] p-[15px] rounded-[10px] mt-[10px]">
                                <h1 className='font-[500] text-[17px]'>{t("Bill Summary")}</h1>

                                <div className="flex items-center justify-between py-[3px]">
                                    <h1>{t("Item Total")}</h1>
                                    <span className='font-[500]'>{Currency}{detailsdata?.subtotal}</span>
                                </div>

                                <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                    <h1>{t("Safety Fees")}</h1>
                                    <span className='font-[500]'>+{Currency}{detailsdata?.safty_fees}</span>
                                </div>

                                {detailsdata?.total_extra_charge && <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                    <h1>{t("Total Extra Charge")}</h1>
                                    <span className='font-[500]'>+{Currency}{detailsdata?.total_extra_charge}</span>
                                </div>}

                                {detailsdata?.wall_amt !== "0" && <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                    <h1>{t("Wallet Amount")}</h1>
                                    <span className='font-[500]'>-{Currency}{detailsdata?.wall_amt}</span>
                                </div>}

                                {detailsdata?.cou_amt !== "0" && <div className="flex items-center text-[#682afb] justify-between py-[3px] border-t-[2px] border-dashed">
                                    <h1>{t("Coupon Amount")}</h1>
                                    <span className='font-[500]'>-{Currency}{detailsdata?.cou_amt}</span>
                                </div>}

                                <div className="border-t-[2px] border-dashed mt-[5px]">
                                    <div className="py-[5px] flex items-start justify-between font-[500]">
                                        <h1>{t("Total")}</h1>
                                        <span className='font-[500]'>{Currency}{Number(detailsdata?.total_amt) + Number(detailsdata?.total_extra_charge)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="max-_995_:block hidden">

                                <div className="border-[1px] py-[5px] p-[15px] rounded-[10px] mt-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Extra Charge")}</h1>

                                    <div className="flex items-center justify-between py-[3px]">
                                        <h1>{t("Total Extra Charge")}</h1>
                                        <span className='font-[500]'>{Currency}{detailsdata?.total_extra_charge}</span>
                                    </div>

                                    {detailsdata?.is_paid === "1" && <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                        <h1>{t("Charge Payment Id")}</h1>
                                        <span className='font-[500]'>{detailsdata?.charge_payment_id}</span>
                                    </div>}

                                    {detailsdata?.is_paid === "1" && <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                        <h1>{t("Charge Transaction Id")}</h1>
                                        <span className='font-[500]'>{detailsdata?.charge_transaction_id}</span>
                                    </div>}

                                    <div className="flex items-center justify-between py-[3px] border-t-[2px] border-dashed">
                                        <h1>{t("Charge Status")}</h1>
                                        <span className='font-[500]'>{detailsdata?.is_paid === "0" ? t("Unpaid") : t("Paid")}</span>
                                    </div>

                                </div>

                                {secureLocalStorage.getItem("mywallet") !== 0 && <div className="border-[1px] border-gray-300 rounded-[10px] py-[10px] px-[20px] mt-[20px]">
                                    <div className="flex items-center justify-between mb-[10px]">
                                        <h1 className='font-[500] text-[17px]'>{t("Pay from Wallet")}</h1>
                                        <label className="switch">
                                            <input type="checkbox" checked={isDriverSelected} onChange={toggleDriverSelection} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                    <div className="border-[1px] border-[#8080803b] p-[10px] rounded-[10px] flex items-center justify-between">
                                        <div className="flex items-center gap-[5px]">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                                            </svg>
                                            <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                                        </div>
                                        <h1 className='font-[500] text-[17px] text-[#682afb]'>{Currency}{mywallet}</h1>
                                    </div>
                                </div>}

                                {detailsdata?.is_paid === "0" && <button onClick={handleContinue} className='button rounded-[10px] mt-[10px]'>{t("Pay Extra Charge")} {Currency + detailsdata?.total_extra_charge}</button>}
                            </div>

                        </div>
                    </div>

                </div>
            }

            {showreviewbox && <div onClick={() => setShowReviewBox(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="px-[20px] py-[10px] bottem_box">
                    <h1 className='text-center font-[500] text-[20px] leading-5'>Please submit review for <br /> service center</h1>

                    <div className="flex items-center justify-center gap-[10px] mt-[20px]">
                        {[1, 2, 3, 4, 5].map((item, index) => {
                            return <div key={index} onClick={() => setRating(item)} className={`cursor-pointer ${rating >= item ? "text-orange-400" : "text-gray-300"}`}>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                </svg>
                            </div>
                        })}
                    </div>
                    <textarea onChange={(e) => setComment(e.target.value)} className='w-full max-h-[200px] min-h-[200px] p-[10px] font-[500] border-[2px] mt-[10px] rounded-[10px] outline-none focus-within:border-[#682afb]' placeholder='Comment' />
                    <button onClick={HandleSubmit} className='button rounded-[10px] mt-[20px]'>
                        {ratinglod
                            ? <div className="loader mx-auto"></div>
                            : <span>Submit</span>}
                    </button>
                </div>
            </div>}

            {showpaymentlist && <div onClick={() => setShowPaymentList(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                    <Payment Index={2} Amount={Paymentamt} />
                </div>
            </div>}

            {showchatlist && <div onClick={() => setShowChatList(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                    <Chat index={0} storeid={detailsdata?.store_id} setShowChatList={setShowChatList} />
                </div>
            </div>}

            {bookinglod && <div className="h-[100vh] w-full bg-[#00000067] fixed top-0 left-0 z-[999] flex items-center justify-center">
                <div style={{ width: "33px", height: "33px" }} className="loader"></div>
            </div>}

        </div>
    )
}

export default OrderDetails;
/* jshint ignore:end */